import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWindowClose, FaSearch } from 'react-icons/fa';
import CommonModal from './CommonModal';
import {
  catchError,
  commonModalSetting,
  enterFn,
  maskingInfo,
} from 'JS/common';
import { searchSubscriptionUser } from 'JS/API';

const UserSearchModal = ({ onClose, onSelect }) => {
  const [searchTarget, setSearchTarget] = useState('name');
  const [searchTxt, setSearchTxt] = useState('');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [innerAlertBox, setInnerAlertBox] = useState({
    mode: '',
    context: '',
    bool: false,
  });
  const [innerAlert, setInnerAlert] = useState('');
  const navigate = useNavigate();

  const handleBackgroundClick = e => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
      onClose();
    }
  };

  const handleSearch = async () => {
    if (!searchTxt.trim()) {
      return commonModalSetting(
        setInnerAlertBox,
        true,
        'alert',
        '검색어를 입력해 주세요.'
      );
    }
    setSearching(true);
    const result = await searchSubscriptionUser(
      searchTarget,
      searchTxt.trim(),
      1,
      20
    );
    setSearching(false);

    if (typeof result === 'object') {
      const users = result?.data?.data || [];
      setResults(users);
      if (users.length === 0) {
        commonModalSetting(
          setInnerAlertBox,
          true,
          'alert',
          '검색 결과가 없습니다.'
        );
      }
    } else {
      catchError(result, navigate, setInnerAlertBox, setInnerAlert);
    }
  };

  const handlePick = user => {
    onSelect(user);
    onClose();
  };

  return (
    <>
      <div className='modal-background' onClick={handleBackgroundClick}>
        <div className='modal user-search'>
          <div className='topBar'>
            <h2>회원 검색</h2>
            <div onClick={onClose}>
              <FaWindowClose />
            </div>
          </div>
          <hr />
          <div className='wrap'>
            <div className='search-section'>
              <div className='search-row'>
                <select
                  value={searchTarget}
                  onChange={e => setSearchTarget(e.target.value)}>
                  <option value='name'>이름</option>
                  <option value='email'>이메일</option>
                  <option value='id'>아이디</option>
                </select>
                <input
                  type='text'
                  value={searchTxt}
                  onChange={e => setSearchTxt(e.target.value)}
                  onKeyDown={e => enterFn(e, handleSearch)}
                  placeholder='검색어 입력'
                  autoFocus
                />
                <button
                  className='search-btn'
                  onClick={handleSearch}
                  disabled={searching}>
                  <FaSearch />
                </button>
              </div>

              {results.length > 0 && (
                <div className='search-results'>
                  {results.map(user => {
                    const userPk = user.user_pk || user.id;
                    return (
                      <div
                        key={userPk}
                        className='search-result-item'
                        onClick={() => handlePick(user)}>
                        <span className='name'>
                          {user.user_name || user.name
                            ? maskingInfo(
                                'name',
                                user.user_name || user.name
                              )
                            : '-'}
                        </span>
                        <span className='email'>
                          {user.user_email || user.email
                            ? maskingInfo(
                                'email',
                                user.user_email || user.email
                              )
                            : '-'}
                        </span>
                        <span className='id'>
                          {user.user_id
                            ? maskingInfo('id', user.user_id)
                            : '-'}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {innerAlertBox.bool && (
        <CommonModal
          setModal={setInnerAlertBox}
          modal={innerAlertBox}
          okFn={() => {
            if (innerAlert === 'logout') navigate('/');
          }}
        />
      )}
    </>
  );
};

export default UserSearchModal;
